module.exports = __webpack_public_path__ + "static/media/puzzle_1.e0460525.jpg";